import {FILE_DATA, LOADER_STATUS, SAVE_FILE_DATA } from "./constants";

export const initialState = {
    loaderStatus: false,
    fileData: [],
};
  
  /* eslint-disable default-case, no-param-reassign */
  const gstr2xFileReducer = (state = initialState, action) =>{
      switch (action.type) {
        
        case LOADER_STATUS:
          return {
            ...state,
            loaderStatus:action.loaderStatus
          }
        case SAVE_FILE_DATA:
          return {
            ...state,
            fileData:action.payload
          }
        default:
          return state;
      }
    };
  
  export default gstr2xFileReducer;
